export const calculateCharacterDifference = (str1 = "", str2 = "") => {
  const string1 = str1.toLowerCase().trim();
  const string2 = str2.toLowerCase().trim();

  const m = string1.length;
  const n = string2.length;

  let prevRow = new Array(n + 1).fill(0);
  let currRow = new Array(n + 1).fill(0);

  for (let j = 0; j <= n; j++) {
    prevRow[j] = j;
  }

  for (let i = 1; i <= m; i++) {
    currRow[0] = i;
    for (let j = 1; j <= n; j++) {
      if (string1[i - 1] === string2[j - 1]) {
        currRow[j] = prevRow[j - 1];
      } else {
        currRow[j] = 1 + Math.min(
          currRow[j - 1],   // Insert
          prevRow[j],       // Remove
          prevRow[j - 1]    // Replace
        );
      }
    }
    prevRow = [...currRow];
  }

  return currRow[n];
};
